import axios from "axios";
import { product_subscription, stateUrl, cityUrl, indonesia_payment } from "../../js/path";

const apiEndpoint = process.env.VUE_APP_INDONESIA_PAYMENT;

export default {
  data() {
    return {
      tableData: {
        doctors: [],
        total: 0,
        current_page: 1,
        last_page: 1,
        size: 20,
      },

      fields: [
        // { key: "doctor_id", sortable: true },
        {key: "mobile_number", label: "Mobile number"},
        { key: "fname", label: "Member Name" },
        { key: "city", label: "City" },
        { key: "state", label: "State" },
        { key: "product_name", label: "Product Name" },
        { key: "start_date", label: "Start Date" },
        { key: "end_date", label: "End Date" },
        { key: "dashboard", label: "Dashboard" },
        { key: "renew", label: "Action" },
        // { key: "Product_info", label: "Product Info"}
      ],
      showModal: false,
      showRenewModal: false,
      showProductRenewModal: false,
      productRenewItem: {},
      productRenewForm: {
        months: null,
        start_date: "",
        end_date: "",
      },
      renewItem: {},
      renewForm: {
        plan: null,
        months: null,
        start_date: "",
        end_date: "",
      },
      renew_plans: [],
      wow_plans: [],
      renew_durations: [3, 6, 9, 12],
      form: {},
      product_fields: [
        { key: 'product', label: 'Product' },
        // { key: 'status', label: 'Status' },
        { key: 'start_date', label: 'Start Date' },
        { key: 'end_date', label: 'End Date' }
      ],
      productInfo: [],
      selected_plans: "all",
      filter_plan_options: [
        { value: 'all', text: 'All'},
        { value: 1, text: '1 Day' },
        { value: 5, text: '5 Day' },
        { value: 10, text: '10 Day' },
        { value: 15, text: '15 Day' },
        { value: 20, text: '20 Day' },
        { value: 30, text: '30 Day' },
        { value: 'expired', text: 'Already Expired' },
        { value: 'custom', text: 'Custom' }
      ],
      custom_days: null,
      selected_product: "all",
      filter_product_options: [
        { value: "all", text: "All Products" },
        { value: "my_clinic", text: "My Clinic" },
        { value: "gmb", text: "GMB" },
        { value: "health_saarthi", text: "Health Saarthi" },
      ],
      currentPage: 1,
      filter: "",
      pageNo: null,
      selected_state: { state: "All" },
      selected_city: { city: "All" },
      state_list: [{ state: "All" }],
      city_list: [{ city: "All" }],
    };
  },

  methods: {
    // Maps a split-list row to the correct start/end date field for its product
    productDate(item, boundary) {
        const name = (item.product_name || "").toLowerCase();

        let prefix;
        if (name.includes("clinic")) prefix = "subscription";
        else if (name.includes("gmb")) prefix = "gmb";
        else if (name.includes("saarthi")) prefix = "health_saarthi";
        else return "-";

        const value = item[`${prefix}_${boundary}_date`];
        return value ? new Date(value).toLocaleDateString() : "-";
    },
    async fetchStates() {
        try {
            const data = await this.getRequest(stateUrl.fetchState);
            if (data.status) {
                this.state_list = [{ state: "All" }, ...data.response];
            }
        } catch (err) {
            console.error(err);
        }
    },

    async fetchCities() {
        // reset city list whenever we (re)load it
        this.city_list = [{ city: "All" }];

        if (!this.selected_state || this.selected_state.state === "All") return;

        try {
            const url = `${cityUrl.city}/India/${encodeURIComponent(this.selected_state.state)}`;
            const data = await this.getRequest(url);
            if (data.status) {
                this.city_list = [{ city: "All" }, ...data.response];
            }
        } catch (err) {
            console.error(err);
        }
    },

    async onStateChange() {
        this.selected_city = { city: "All" };
        await this.fetchCities();
        this.currentPage = 1;
        this.fetchData();
    },

    onCityChange() {
        this.currentPage = 1;
        this.fetchData();
    },

    async fetchRenewPlans() {
        try {
            const url = `${apiEndpoint}${indonesia_payment.getplans}?product_id=${process.env.VUE_APP_WOW_PRODUCT_ID}&filter=active`;
            const res = await axios.get(url);
            const list = res?.data?.response?.data || [];

            // only show basic, pro and advanced plans
            const allowed = ["basic", "pro", "advanced"];
            this.renew_plans = list
                .filter((p) => {
                    const key = `${p.name || ""} ${p.slug || ""}`.toLowerCase();
                    return allowed.some((a) => key.includes(a));
                })
                .map((p) => ({
                    value: p.slug,
                    text: p.name,
                    id: p.id ?? p._id,
                    price: p.price,
                }));

            // preselect the row's current plan using the REAL slug from the list
            if (!this.renewForm.plan && this.renewItem.plan_name) {
                const pn = this.renewItem.plan_name.toLowerCase();
                const sel = this.renew_plans.find((p) =>
                    `${p.text} ${p.value}`.toLowerCase().includes(pn)
                );
                if (sel) {
                    this.renewForm.plan = sel.value;
                    this.renewForm.plan_id = sel.id;
                    this.renewForm.price = sel.price;
                }
            }
        } catch (err) {
            console.error(err);
        }
    },

    openProductRenew(item) {
        this.productRenewItem = item;
        this.productRenewForm = { months: null, start_date: "", end_date: "" };
        this.showProductRenewModal = true;
    },

    selectProductRenewDuration(months) {
        this.productRenewForm.months = months;
        const start = new Date();
        const end = new Date(start);
        end.setMonth(end.getMonth() + months);
        this.productRenewForm.start_date = this.formatRenewDate(start);
        this.productRenewForm.end_date = this.formatRenewDate(end);
    },

    async handleProductRenew(bvModalEvent) {
        if (bvModalEvent) bvModalEvent.preventDefault();

        if (!this.productRenewForm.months) {
            this.$store.commit("toast/updateStatus", {
                status: true,
                icon: "error",
                title: "Please select a duration",
            });
            return;
        }

        const name = (this.productRenewItem.product_name || "").toLowerCase();
        const productKey = name.includes("gmb") ? "gmb" : "health_saarthi";

        const payload = {
            member_id: Number(this.productRenewItem.doctor_id),
            product_name: productKey,
            start_date: this.productRenewForm.start_date,
            end_date: this.productRenewForm.end_date,
        };

        // Health Saarthi also accepts is_active (and an optional note object)
        if (productKey === "health_saarthi") {
            payload.is_active = true;
        }

        this.$store.commit("loader/updateStatus", true);
        try {
            const res = await this.postRequest(
                product_subscription.productSubscriptionRenewUrl,
                payload
            );
            if (res && res.status) {
                this.$store.commit("toast/updateStatus", {
                    status: true,
                    icon: "success",
                    title: res.message || "Subscription renewed successfully",
                });
                this.showProductRenewModal = false;
                this.fetchData();
            } else {
                this.$store.commit("toast/updateStatus", {
                    status: true,
                    icon: "error",
                    title: res?.message || "Renew failed",
                });
            }
        } catch (err) {
            this.$store.commit("toast/updateStatus", {
                status: true,
                icon: "error",
                title: err?.response?.data?.message || "Renew failed",
            });
        }
        this.$store.commit("loader/updateStatus", false);
    },

    isSubscriptionExpired(item) {
        if (!item || !item.subscription_end_date) return false;
        const end = new Date(item.subscription_end_date);
        const today = new Date();
        end.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        return end < today;
    },

    // renew allowed when the clinic subscription expires within the next 1 month
    // (includes already-expired subscriptions)
    isRenewEligible(item) {
        if (!item || !item.subscription_end_date) return false;
        const end = new Date(item.subscription_end_date);
        const limit = new Date();
        end.setHours(0, 0, 0, 0);
        limit.setHours(0, 0, 0, 0);
        limit.setMonth(limit.getMonth() + 1);
        return end <= limit;
    },

    // GMB / Health Saarthi renew eligibility — product end date within the next 1 month
    isProductRenewEligible(item) {
        const name = (item.product_name || "").toLowerCase();
        let prefix;
        if (name.includes("gmb")) prefix = "gmb";
        else if (name.includes("saarthi")) prefix = "health_saarthi";
        else return false;

        const end = item[`${prefix}_end_date`];
        if (!end) return false;

        const e = new Date(end);
        const limit = new Date();
        e.setHours(0, 0, 0, 0);
        limit.setHours(0, 0, 0, 0);
        limit.setMonth(limit.getMonth() + 1);
        return e <= limit;
    },

    // expired check based on the row's product end date
    isRowExpired(item) {
        const name = (item.product_name || "").toLowerCase();
        let prefix;
        if (name.includes("clinic")) prefix = "subscription";
        else if (name.includes("gmb")) prefix = "gmb";
        else if (name.includes("saarthi")) prefix = "health_saarthi";
        else return false;

        const end = item[`${prefix}_end_date`];
        if (!end) return false;

        const e = new Date(end);
        const t = new Date();
        e.setHours(0, 0, 0, 0);
        t.setHours(0, 0, 0, 0);
        return e < t;
    },

    openRenew(item) {
        this.renewItem = item;

        this.renewForm = {
            plan: null,
            plan_id: null,
            price: null,
            months: null,
            start_date: "",
            end_date: "",
        };
        this.showRenewModal = true;
        this.fetchRenewPlans();
        this.fetchWowPlans();
    },

    async fetchWowPlans() {
        try {
            const res = await axios.get(product_subscription.wowPlansUrl);

            const d = res.data;
            const arr =
                (Array.isArray(d?.Plans) && d.Plans) ||
                (Array.isArray(d?.plans) && d.plans) ||
                (Array.isArray(d?.response?.data) && d.response.data) ||
                (Array.isArray(d?.data?.data) && d.data.data) ||
                (Array.isArray(d?.data) && d.data) ||
                (Array.isArray(d?.response) && d.response) ||
                (Array.isArray(d) && d) ||
                null;

            if (arr) {
                this.wow_plans = arr;
            } else if (d && (d.slug || d._id)) {
                // API returned a single plan object
                this.wow_plans = [d];
            } else if (d?.response && (d.response.slug || d.response._id)) {
                this.wow_plans = [d.response];
            } else if (d?.data && (d.data.slug || d.data._id)) {
                this.wow_plans = [d.data];
            } else {
                this.wow_plans = [];
            }
        } catch (err) {
            console.error(err);
            this.wow_plans = [];
        }
    },

    // find the wow-plan _id whose slug matches the selected plan value (e.g. "wc_pro")
    resolveWowPlanId() {
        if (!Array.isArray(this.wow_plans)) return null;

        const slug = (this.renewForm.plan || "").toLowerCase();
        const match = this.wow_plans.find(
            (w) => (w.slug || "").toLowerCase() === slug
        );

        return match ? match._id ?? match.id : null;
    },

    selectRenewPlan(p) {
        this.renewForm.plan = p.value;
        this.renewForm.plan_id = p.id;
        this.renewForm.price = p.price;
    },

    selectRenewDuration(months) {
        this.renewForm.months = months;

        const start = new Date();
        const end = new Date(start);
        end.setMonth(end.getMonth() + months);

        this.renewForm.start_date = this.formatRenewDate(start);
        this.renewForm.end_date = this.formatRenewDate(end);
    },

    formatRenewDate(d) {
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    },

    async handleRenew(bvModalEvent) {
        if (bvModalEvent) bvModalEvent.preventDefault();

        if (!this.renewForm.plan) {
            this.$store.commit("toast/updateStatus", {
                status: true,
                icon: "error",
                title: "Please select a plan",
            });
            return;
        }

        if (!this.renewForm.months) {
            this.$store.commit("toast/updateStatus", {
                status: true,
                icon: "error",
                title: "Please select a duration",
            });
            return;
        }

        const doctorId = Number(this.renewItem.doctor_id);

        const payload = {
            doctor: {
                mobile_number: this.renewItem.mobile_number,
                doctor_id: doctorId,
            },
            plan: {
                slug: this.renewForm.plan,
            },
            subscription: {
                valid_from: this.renewForm.start_date,
                valid_through: this.renewForm.end_date,
                doctor_id: doctorId,
            },
        };

        this.$store.commit("loader/updateStatus", true);

        try {
            const res = await axios.post(
                `${apiEndpoint}${indonesia_payment.renewFromWow}`,
                payload
            );

            if (res.data && res.data.status) {
                // 2nd API: update subscriber wow details only after renew succeeds
                await this.updateSubscriberWowDetails();

                this.$store.commit("toast/updateStatus", {
                    status: true,
                    icon: "success",
                    title: res.data.message || "Subscription renewed successfully",
                });
                this.showRenewModal = false;
                this.fetchData();
            } else {
                this.$store.commit("toast/updateStatus", {
                    status: true,
                    icon: "error",
                    title: res.data?.message || "Renew failed",
                });
            }
        } catch (err) {
            this.$store.commit("toast/updateStatus", {
                status: true,
                icon: "error",
                title: err?.response?.data?.message || "Renew failed",
            });
        }

        this.$store.commit("loader/updateStatus", false);
    },

    // 2nd call after a successful renew — subscriber-wow-update-details/{id}
    async updateSubscriberWowDetails() {
        // make sure wow-plans are loaded before matching plan_id
        if (!this.wow_plans || !this.wow_plans.length) {
            await this.fetchWowPlans();
        }

        const mobileNumber = this.renewItem.mobile_number;
        const url = `${product_subscription.subscriberWowUpdateDetailsUrl}/${mobileNumber}`;

        const toIso = (d) => new Date(`${d}T00:00:00.000Z`).toISOString();

        const months = this.renewForm.months;
        const years = months / 12;
        const description = Number.isInteger(years)
            ? `Renewed for ${years} year${years > 1 ? "s" : ""}`
            : `Renewed for ${months} months`;

        const body = {
            plan_id: this.resolveWowPlanId(),
            valid_from: toIso(this.renewForm.start_date),
            valid_through: toIso(this.renewForm.end_date),
            is_active: true,
            description,
        };

        await axios.patch(url, body);
    },

    onPlanChange() {
        this.currentPage = 1;
        // For "custom" wait until the user enters days and clicks Apply
        if (this.selected_plans === "custom") {
            this.custom_days = null;
            return;
        }
        this.fetchData();
    },
    isExpiringWithinDays(doctor) {
      if (this.selected_plans === "all") return true;

        const days =
        this.selected_plans === "custom"
        ? Number(this.custom_days)
        : Number(this.selected_plans);

        if (!days) return true;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const maxDate = new Date(today);
      maxDate.setDate(maxDate.getDate() + days);

      const endDates = [
        doctor.health_saarthi_end_date,
        doctor.subscription_end_date,
        doctor.gmb_end_date,
      ];

      return endDates.some(date => {
        if (!date) return false;

        const endDate = new Date(date);
        endDate.setHours(0, 0, 0, 0);

        return endDate >= today && endDate <= maxDate;
      });
    },
    async openModal(item) {
      this.form = item;

      let subscription = {};

      try {
        let url =
          product_subscription.productSubscriptionDataUrl +
          `?mobile_number=${item.mobile_number}`;

        const res = await this.getRequest(url);

        if (res.status) {
          subscription = res;
        }
      } catch (error) {
        console.log(error);
      }

      this.productInfo = [
        {
          product: `My Clinic ${subscription.plan?.name ? `(${subscription.plan.name})` : ''}`,
          status: item.my_clinic,
          start_date: subscription.start_date
            ? new Date(subscription.start_date).toLocaleDateString()
            : "-",
          end_date: subscription.end_date
            ? new Date(subscription.end_date).toLocaleDateString()
            : "-"
        },
        {
          product: "GMB",
          status: item.gmb,
          start_date: item.gmb_start_date
            ? new Date(item.gmb_start_date).toLocaleDateString()
            : "-",
          end_date: item.gmb_end_date
            ? new Date(item.gmb_end_date).toLocaleDateString()
            : "-"
        },
        {
          product: "Health Saarthi",
          status: item.health_saarthi,
          start_date: item.health_saarthi_start_date
            ? new Date(item.health_saarthi_start_date).toLocaleDateString()
            : "-",
          end_date: item.health_saarthi_end_date
            ? new Date(item.health_saarthi_end_date).toLocaleDateString()
            : "-"
        }
      ];
      this.showModal = true;
    },
    // ✅ MAIN API CALL
    async fetchData() {

      let url =
          product_subscription.productSubscriptionUrl +
          `?pagination=true&page=${this.currentPage}&size=20`;

        if (this.filter) {
          url += `&search=${this.filter}`;
        }

        if (this.selected_plans === "custom") {
            if (this.custom_days) {
                url += `&days=${this.custom_days}`;
            }
        } else if (this.selected_plans === "expired") {
            url += `&expired=1`;
        } else if (this.selected_plans !== "all") {
            url += `&days=${this.selected_plans}`;
        }

        if (this.selected_product !== "all") {
            url += `&product_name=${this.selected_product}`;
        }

        if (this.selected_state && this.selected_state.state !== "All") {
            url += `&state=${encodeURIComponent(this.selected_state.state)}`;
        }

        if (this.selected_city && this.selected_city.city !== "All") {
            url += `&city=${encodeURIComponent(this.selected_city.city)}`;
        }

      this.updateUrl();

    this.$store.commit("loader/updateStatus", true);

      try {
        const res = await this.getRequest(url);

        if (res.status) {
          this.tableData = res;
          if (this.selected_plans !== "all" && this.selected_plans !== "expired") {
            this.tableData.data = this.tableData.data.filter(
              doctor => this.isExpiringWithinDays(doctor)
            );
          }
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err?.data?.message || "Something went wrong",
        });
      }

      this.$store.commit("loader/updateStatus", false);
    },

    // ✅ SEARCH BUTTON
    searchFor() {
      this.currentPage = 1;
      this.fetchData();
    },

    // ✅ ENTER SEARCH
    search(event) {
      if (event.keyCode === 13) {
        this.currentPage = 1; // ✅ reset page
        this.fetchData();
      }

      // ✅ NEW: when search is cleared
      if (!this.filter || this.filter === "") {
        this.currentPage = 1; // reset page
        this.fetchData();
      }
    },

    // ✅ MANUAL PAGE INPUT
    filterPage() {
      if (this.pageNo && this.pageNo > 0) {
        this.currentPage = Number(this.pageNo);
        this.fetchData();
      }
    },

    // ✅ URL SYNC (clean)
    updateUrl() {
      const url = new URL(window.location);

      if (this.filter) url.searchParams.set("search", this.filter);
      else url.searchParams.delete("search");

        url.searchParams.delete("days");
        url.searchParams.delete("expired");

      if (this.selected_plans === "expired") {
        url.searchParams.set("expired", 1);
      } else if (this.selected_plans === "custom") {
        if (this.custom_days) url.searchParams.set("days", this.custom_days);
        } else if (this.selected_plans !== "all") {
        url.searchParams.set("days", this.selected_plans);
      }

      if (this.selected_product !== "all")
        url.searchParams.set("product", this.selected_product);
      else
        url.searchParams.delete("product");

      if (this.selected_state && this.selected_state.state !== "All")
        url.searchParams.set("state", this.selected_state.state);
      else
        url.searchParams.delete("state");

      if (this.selected_city && this.selected_city.city !== "All")
        url.searchParams.set("city", this.selected_city.city);
      else
        url.searchParams.delete("city");

        url.searchParams.set("page", this.currentPage);
        url.searchParams.set("size", 20);
        url.searchParams.set("pagination", true);

      history.pushState({}, "", url);
    },
  },

  watch: {
    currentPage(val) {
      if (val) this.fetchData();
    },
    filter(val) {
      if (!val) {
        this.currentPage = 1;
        this.fetchData();
      }
    }
  },

  async created() {
    if (this.$route.query.search) {
        this.filter = this.$route.query.search;
    }

    if (this.$route.query.page) {
        this.currentPage = Number(this.$route.query.page);
    }

    if (this.$route.query.expired) {
        this.selected_plans = "expired";
    } else if (this.$route.query.days) {
        const days = Number(this.$route.query.days);
        const isPreset = this.filter_plan_options.some(o => o.value === days);
        if (isPreset) {
            this.selected_plans = days;
        } else {
            this.selected_plans = "custom";
            this.custom_days = days;
        }
    }

    if (this.$route.query.product) {
        this.selected_product = this.$route.query.product;
    }

    // load state options (and restore state/city from the URL if present)
    await this.fetchStates();

    if (this.$route.query.state) {
        this.selected_state =
            this.state_list.find((s) => s.state === this.$route.query.state) || { state: "All" };
        await this.fetchCities();
    }

    if (this.$route.query.city) {
        this.selected_city =
            this.city_list.find((c) => c.city === this.$route.query.city) || { city: "All" };
    }

    this.fetchData();
  },
};